













/** Значение 0 означает «Все» и срезается realValuesOrEmpty перед отправкой */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import MultiSelect from '@/components/MultiSelect.vue';
import '@/extensions';

import { MmSelectOption } from '../types/domain';

const ALL_VALUE = 0;

@Component({
	components: { MultiSelect },
})
export default class MmZoneSelect extends Vue {
	@Prop({ required: true }) readonly options!: MmSelectOption[];

	/** Пустой массив означает «Все» */
	@Prop({ required: true }) readonly value!: number[];

	@Prop({ default: false }) readonly disabled!: boolean;

	/** Пока идёт загрузка, события списка игнорируем: он отдаёт пустой массив и стёр бы выбор */
	@Prop({ default: false }) readonly loading!: boolean;

	@Prop({ default: '' }) readonly placeholder!: string;

	get allLabel(): string {
		return this.$t('shared.selectBox.all') as string;
	}

	get defaultValue(): MmSelectOption[] {
		return [{ value: ALL_VALUE, label: this.allLabel }];
	}

	get items(): MmSelectOption[] {
		if (!this.options || this.options.length === 0) {
			return this.defaultValue;
		}

		return this.options;
	}

	get selectList(): number[] {
		if (this.value.length === 0) {
			return [ALL_VALUE];
		}

		const realIds = this.getRealOptionIds();

		if (realIds.length > 0 && this.isSameValue(this.value, realIds)) {
			return [ALL_VALUE];
		}

		return this.value;
	}

	get placeholderText(): string {
		return this.placeholder !== '' ? this.placeholder : this.allLabel;
	}

	/** MultiSelect шлёт событие и на программную установку, и при загрузке — без проверок будет цикл */
	handleChange(next: number[]): void {
		if (this.loading) {
			return;
		}

		const value = this.normalizeOutboundValue(next ? next : []);

		if (this.isSameValue(value, this.value)) {
			return;
		}

		this.$emit('change', value);
	}

	private getRealOptionIds(): number[] {
		if (!this.options || this.options.length === 0) {
			return [];
		}

		const ids: number[] = [];

		for (let i = 0; i < this.options.length; i += 1) {
			const id = this.options[i].value;

			if (id !== ALL_VALUE) {
				ids.push(id);
			}
		}

		return ids;
	}

	/** Ноль срезается, а полный набор идентификаторов уходит как «Все» — пустым массивом */
	private normalizeOutboundValue(raw: number[]): number[] {
		const result = raw.slice().realValuesOrEmpty();
		const realIds = this.getRealOptionIds();

		if (realIds.length > 0 && this.isSameValue(result, realIds)) {
			return [];
		}

		return result;
	}

	/** Начальный loading доводим вручную: наблюдатель без immediate не сработает, а в created нет $refs */
	mounted(): void {
		if (this.loading) {
			this.onLoadingChanged(true);
		}
	}

	@Watch('loading')
	onLoadingChanged(next: boolean): void {
		const select = this.$refs.select as any;

		if (select && typeof select.toggleLoading === 'function') {
			select.toggleLoading(next);
		}
	}

	private isSameValue(a: number[], b: number[]): boolean {
		if (a.length !== b.length) {
			return false;
		}

		const left = a.slice().sort();
		const right = b.slice().sort();

		for (let i = 0; i < left.length; i += 1) {
			if (left[i] !== right[i]) {
				return false;
			}
		}

		return true;
	}
}
